export enum PaymentCardType {
  MasterCard = 'MASTERCARD',
  Visa = 'VISA',
  Amex = 'AMEX',
}
